import styled from 'styled-components';

import { colorTokens } from '../variables';

export const Wrapper = styled.div<{ size?: number }>`
  width: ${(props) => (props.size ? `${props.size}px` : '40px')};
  height: ${(props) => (props.size ? `${props.size}px` : '40px')};
  background-color: ${colorTokens.text.disabled};
  text-align: center;
  border-radius: 50%;
  flex-shrink: 0;
  overflow: hidden;
  border: 1px solid ${colorTokens.text.contrast};
  margin-left: -7px;
  :first-of-type {
    outline: none;
    margin-left: 0;
  }
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const Image = styled.img<{ height: string; width: string }>`
  display: inline;
  margin: 0 auto;
  margin-left: 0%;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
`;
